var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-areas"},_vm._l((_vm.buttonAreas),function(item){return _c(item.component,{key:item.alias,tag:"component",attrs:{"entity":_vm.entity,"entities":_vm.entities}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }